import { supabase } from "@/integrations/supabase/client";

type OAuthClient = { name?: string | null; client_uri?: string | null };
type AuthorizationDetails = {
  client?: OAuthClient | null;
  scope?: string | null;
  redirect_uri?: string | null;
  redirect_url?: string | null;
  redirect_to?: string | null;
};

type OAuthApi = {
  getAuthorizationDetails: (
    id: string,
  ) => Promise<{ data: AuthorizationDetails | null; error: { message: string } | null }>;
  approveAuthorization: (
    id: string,
  ) => Promise<{ data: AuthorizationDetails | null; error: { message: string } | null }>;
  denyAuthorization: (
    id: string,
  ) => Promise<{ data: AuthorizationDetails | null; error: { message: string } | null }>;
};

// namespace `auth.oauth` ما زال beta في الـSDK — غلاف مطبوع صغير بدل any منتشر.
export function oauth() {
  return (supabase.auth as unknown as { oauth: OAuthApi }).oauth;
}
